<template>
  <div>
    <div class="d-flex">
      <div class="mr-auto">
        <button class="btn btn-secondary" @click="refresh">
          <i class="fas fa-sync-alt fa-fw"></i>
        </button>
        <button class="btn btn-purple" disabled v-if="canCreate" @click="onCreate">
          <i class="far fa-file fa-fw"></i>
        </button>
      </div>
      <div class="align-self-end">
        <input-debounced
            v-model="search"
            :clearable="true"
            :autofocus="true"
            placeholder="Search"
            class="search-bar w-300 mb-2"
        ></input-debounced>
      </div>
    </div>
    <base-table
        :base-url="urlWithFilters"
        ref="baseTable"
        @load-success="onLoadSuccess"
        @refresh="onRefresh"
        :current-page="currentPage"
        v-loading="isRefreshing"
        element-loading-spinner="el-icon-loading"
    >
      <template v-slot>
        <el-table
            :data="items"
            stripe
            class="w-100"
        >
          <el-table-column
              prop="model.id"
              label="Id"
              min-width="80"
          ></el-table-column>
          <el-table-column
              prop="model.send_list.name"
              label="Send List"
              min-width="350"
          ></el-table-column>
          <el-table-column
              prop="model.status_text"
              label="Status"
              min-width="100"
          ></el-table-column>
          <el-table-column
              prop="model.state_text"
              label="State"
              min-width="100"
          ></el-table-column>
          <el-table-column
              prop="model.message_count"
              label="Message Count"
              min-width="120"
          ></el-table-column>
          <el-table-column label="Actions" v-slot="{row}">
            <actions-column :row="row" @edit="onEdit" @view="onView" @delete="onDelete" @restore="onRestore"></actions-column>
          </el-table-column>
        </el-table>
      </template>
    </base-table>
    <el-pagination
        layout="prev, pager, next"
        :total="total"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        class="text-right"
    ></el-pagination>
  </div>
</template>

<script>
import BaseTable from '../../../components/bulk-message/table';
import ActionsColumn from '../../../components/bulk-message/actions-column';
import eventBus from "../../../event-bus";

export default {
  extends: BaseTable,

  components: {
    ActionsColumn,
  },

  props: {
    canCreate: Boolean,
    createUrl: String,
  },

  methods: {
    /**
     * @return {undefined}
     */
    onCreate() {
      window.location = this.createUrl;
    },

    /**
     * @param {string} url
     */
    onEdit({url}) {
      window.location = url;
    },

    /**
     * @param {string} url
     */
    onView({url}) {
      window.location = url;
    },
  },

  created() {
    eventBus.$on('refresh-bulk-message-table', this.refresh);
  },

  beforeDestroy() {
    eventBus.$off('refresh-bulk-message-table', this.refresh);
  }
}
</script>
